class PartnerDeliverables {
  constructor() {
    this.section = document.querySelector(".section--partner-deliverables");
    if (!this.section) return;

    this.track = this.section.querySelector(".partner-deliverables__track");
    this.fill = this.section.querySelector(
      ".partner-deliverables__progress span",
    );
    this.progressBar = this.section.querySelector(
      ".partner-deliverables__progress",
    );

    this.setup();
  }

  setup() {
    const getScrollDistance = () => this.track.scrollWidth - window.innerWidth;

    gsap.to(this.track, {
      x: () => -getScrollDistance(),
      ease: "none",
      scrollTrigger: {
        trigger: this.section,
        start: "center center",
        end: () => "+=" + getScrollDistance(),
        scrub: 1,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          if (this.fill) {
            gsap.set(this.fill, { scaleX: self.progress });
          }
          if (this.progressBar) {
            this.progressBar.setAttribute(
              "aria-valuenow",
              Math.round(self.progress * 100),
            );
          }
        },
      },
    });

    /* Split-text (and other ScrollTriggers) run before this module; pin + pin-spacer
       change layout/scroll distance for everything below. Refresh so triggers below
       deliverables (e.g. partner-features) get correct start/end. */
    requestAnimationFrame(() => {
      if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.refresh();
      }
    });
  }
}

new PartnerDeliverables();
